import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { featuredComics, categories } from '@/mocks/comics';
import type { Comic } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'romance');
  const [filteredComics, setFilteredComics] = useState<Comic[]>([]);

  const currentCategory = categories.find((c) => c.slug === activeCategory);

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
    }
  }, [slug]);

  useEffect(() => {
    setFilteredComics(
      featuredComics.filter((comic) => comic.categorySlug === activeCategory)
    );
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [activeCategory]);

  return (
    <>
      <title>{currentCategory ? `${currentCategory.name}漫画 - 韩漫大全免费阅读` : '漫画分类 - 韩漫大全'}</title>
      <meta name="description" content={`韩漫大全${currentCategory ? currentCategory.name : ''}漫画分类，收录海量${currentCategory ? currentCategory.name : '韩国'}漫画，免费在线阅读，每日更新最新章节。`} />
      <meta name="keywords" content={`${currentCategory ? currentCategory.name : '韩国'}漫画,韩漫大全,${currentCategory ? currentCategory.name : ''}韩漫推荐,免费韩漫`} />
      <link rel="canonical" href={`https://hanmandq.com/category/${activeCategory}`} />

      <nav aria-label="面包屑导航" className="w-full bg-background-50 border-b border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
          <ol className="flex items-center gap-2 text-xs text-foreground-500">
            <li><Link to="/" className="hover:text-primary-600 transition-colors duration-200">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li className="text-foreground-800 font-medium">
              {currentCategory ? `${currentCategory.name}漫画` : '漫画分类'}
            </li>
          </ol>
        </div>
      </nav>

      <section className="w-full pt-14 pb-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              {currentCategory ? `${currentCategory.name}漫画` : '漫画分类'}
            </h1>
            <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
              发现最受欢迎的{currentCategory?.name || '韩国'}漫画，每日更新最新章节
            </p>
          </div>

          <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
            <Link
              to="/category/romance"
              onClick={() => setActiveCategory('romance')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'romance'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              恋爱
            </Link>
            <Link
              to="/category/thriller"
              onClick={() => setActiveCategory('thriller')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'thriller'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              悬疑
            </Link>
            <Link
              to="/category/fantasy"
              onClick={() => setActiveCategory('fantasy')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'fantasy'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              奇幻
            </Link>
            <Link
              to="/category/school"
              onClick={() => setActiveCategory('school')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'school'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              校园
            </Link>
            <Link
              to="/category/action"
              onClick={() => setActiveCategory('action')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'action'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              动作
            </Link>
            <Link
              to="/category/comedy"
              onClick={() => setActiveCategory('comedy')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'comedy'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              喜剧
            </Link>
            <Link
              to="/category/drama"
              onClick={() => setActiveCategory('drama')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'drama'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              剧情
            </Link>
            <Link
              to="/category/horror"
              onClick={() => setActiveCategory('horror')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeCategory === 'horror'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              恐怖
            </Link>
          </div>

          {filteredComics.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
              </div>
              <p className="mt-4 text-foreground-500">该分类暂无漫画，敬请期待更新</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
              {filteredComics.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      title={`${comic.title} - 韩漫大全免费阅读`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-2 left-2">
                      <span className={`text-xs px-2 py-1 rounded-full font-medium whitespace-nowrap ${
                        comic.status === '连载中'
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-secondary-500 text-background-50'
                      }`}>
                        {comic.status}
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                      <div className="flex items-center gap-1 text-accent-400">
                        <i className="ri-star-fill text-xs"></i>
                        <span className="text-xs text-background-50 font-medium">{comic.rating}</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                    {comic.author} · 共{comic.chapters}话
                  </p>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}